var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.252 9.24124V7.55859C15.252 5.10391 13.5297 3.0234 11.17 2.34387V1.58203C11.17 0.709699 10.4208 0 9.50004 0C8.57925 0 7.83012 0.709699 7.83012 1.58203V2.34387C5.47034 3.0234 3.74809 5.10388 3.74809 7.55859V9.24124C3.74809 11.3974 2.88055 13.442 1.30529 14.9983C1.15092 15.1508 1.10754 15.3758 1.19504 15.5702C1.28254 15.7645 1.48405 15.8906 1.70707 15.8906H6.77284C7.03142 17.0927 8.15598 18 9.50004 18C10.8441 18 11.9686 17.0927 12.2272 15.8906H17.293C17.516 15.8906 17.7175 15.7645 17.805 15.5702C17.8925 15.3758 17.8491 15.1508 17.6948 14.9983C16.1195 13.442 15.252 11.3974 15.252 9.24124ZM8.9434 1.58203C8.9434 1.29125 9.19311 1.05469 9.50004 1.05469C9.80698 1.05469 10.0567 1.29125 10.0567 1.58203V2.13497C9.87348 2.11823 9.68782 2.10938 9.50004 2.10938C9.31227 2.10938 9.12661 2.11823 8.9434 2.13497V1.58203ZM9.50004 16.9453C8.77437 16.9453 8.15565 16.5044 7.92586 15.8906H11.0742C10.8444 16.5044 10.2257 16.9453 9.50004 16.9453ZM2.90682 14.8359C4.17451 13.2261 4.86137 11.2778 4.86137 9.24124V7.55859C4.86137 5.13545 6.94228 3.16406 9.50004 3.16406C12.0578 3.16406 14.1387 5.13545 14.1387 7.55859V9.24124C14.1387 11.2778 14.8256 13.2261 16.0933 14.8359H2.90682Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7364 7.55884C16.7364 7.85008 16.9856 8.08618 17.293 8.08618C17.6004 8.08618 17.8496 7.85008 17.8496 7.55884C17.8496 5.44595 16.9811 3.45952 15.4041 1.96548C15.1867 1.75957 14.8343 1.75954 14.6169 1.96548C14.3995 2.17143 14.3995 2.50531 14.6169 2.71125C15.9837 4.00609 16.7364 5.72766 16.7364 7.55884Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70703 8.08567C2.01445 8.08567 2.26367 7.84956 2.26367 7.55833C2.26367 5.72718 3.0164 4.00562 4.38314 2.71078C4.60052 2.50483 4.60052 2.17095 4.38314 1.96501C4.16579 1.75906 3.81332 1.75906 3.59594 1.96501C2.0189 3.45904 1.15039 5.44544 1.15039 7.55833C1.15039 7.84956 1.39962 8.08567 1.70703 8.08567Z",
    fill: "#0E142C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/notifications-icon.c4ced001fae87c73fa709c675a451c84.svg";
export { ForwardRef as ReactComponent };